

<style lang="scss" scoped>
@import "../../assets/styles/lms/lms.scss";

video{
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Safari and Chrome */
  -moz-transform: rotateY(180deg); /* Firefox */
}
</style>

<template>
  <div>
    <section
      class="section login-section"
      style="background: url('/images/bg-wcursos.png') no-repeat;"
    >
      <div
        :style="[showStudentForm ? {'max-width': '70rem !important'} : '']"
        class="session-content"
        style=" margin:auto; position:relative;overflow-y:scroll;"
      >
        <div class="content">
          <div class="logo" style="max-width: 20rem; margin-bottom:10px;">
            <figure>
              <img src="/images/logo3.png" alt />
            </figure>
          </div>

          <form
            v-if="!showStudentForm" 
            class="form form-default formulario_cadastrar formulario_ja_cadastrado"
            v-on:submit.prevent="makeLogin"
          >
            <div class="form-group-label-icon">
              <label style="margin-bottom:0px;" for="usuario_login" title="Email">
                <i class="material-icons">perm_identity</i>
              </label>
              <input
                :disabled="loading"
                v-model="user.email"
                type="email"
                name="username"
                id="usuario_login"
                required="true"
                class="text_input form-control"
                placeholder="email@email.com"
              />
            </div>
            <!-- user.type != 1 -->
            <div v-if="showStudentForm==false && (videoAvailable || user.type != 1)" class="form-group-label-icon">

              <label style="margin-bottom:0px;" for="senha_login" title="Senha">
                <i class="material-icons">lock</i>
              </label>
              <input
                :disabled="loading"
                v-model="user.password"
                type="password"
                name="password"
                id="senha_login"
                class="text_input form-control"
                placeholder="Digite sua senha"
                required="true"
              />
            </div>

            <!-- //change here for this.user.type == 1 faceid activation-->
            <video v-if="user.type==1" style="display:none" id="player" ref="player" autoplay playsinline width="280" height="200"></video>

            <div class="form-group">
              <button :disabled="loading" class="btn btn-primary md" id="entrar_form">
                <div v-if="!loading">Entrar</div>
                <div v-else>Carregando...</div>
              </button>
            </div>
          </form>

          <div style="color:white;" v-if="showStudentForm">
            <user-edit style="width:100%;" :user="user" :hideType="true" />
            <student-edit style="width:100%;" :student="student" :fullFields="false" />
            <address-edit style="width:100%;" :address="address" />
          </div>
          <button
            v-if="showStudentForm"
            style="margin-top:15px;margin-right:15px;"
            v-on:click="saveStudent()"
            class="btn btn-primary md"
          >Concluir cadastro</button>

          <button
            v-if="showStudentForm"
            style="margin-top:15px;"
            v-on:click="isNew=false"
            class="btn btn-danger md"
          >Cancelar</button>
        </div>
      </div>
      <span class="filter-login" style="background:none;"></span>
    </section>
  </div>
</template>

<script>
import { WebCam } from "vue-web-cam";
import axios from "axios";
import StudentEdit from "../Utils/UserTypes/StudentEdit.vue";
import UserEdit from "../Utils/UserTypes/UserEdit.vue";
import AddressEdit from "../Utils/AddressEditTeste.vue";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      products: [],
      product: null,
      loading: false,
      purchasing: false,
      student: {},
      address: {},
      isNew: false,
      showStudentForm: null,
      user: {},
      imageCapture: null,
      formData: null,
      videoAvailable: false
    };
  },
  components: {
    "vue-web-cam": WebCam,
    "student-edit": StudentEdit,
    "user-edit": UserEdit,
    "address-edit": AddressEdit
  },
  methods: {
    getProductDetails(productId) {
      this.loading = true;
      const path = this.$global.endpoint + "/product/get";
      axios
        .post(path, {
          productId: productId
        })
        .then(res => {
          this.product = res.data;
          this.products.push(res.data);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text:
              "Erro ao recuperar os dados do produto: " +
              this.$route.query.purchaseitem
          });
          console.error(error);
        });
    },

    redirect(user) {
      this.loading = false;
      this.$store.commit("change_user", user);

      this.$router.push("/home/dashboard");
    },

    saveStudent() {
      this.loading = true;
      var vm = this;

      const path = this.$global.endpoint + "/user/student/save";
      axios
        .post(path, {
          user: this.user,
          address: this.address,
          student: this.student
        })
        .then(res => {
          console.log(res.data);
          this.loading = false;
          vm.redirect(res.data.user);
        })
        .catch(error => {
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao salvar o novo usuário"
          });
          console.error(error);
        });
    },
    makeLogin(){ //this.user.type != 1
    console.log("this.videoAvailable", this.videoAvailable)
      if(this.showStudentForm==false && this.user.password != null && (this.videoAvailable || this.user.type != 1)){
        this.login();
      }else{
        this.getStatus();
      }
    },
    getStatus() {
      this.loading = true;
      const path = this.$global.endpoint + "/user/getstatus";
      axios
        .post(path, { email: this.user.email })
        .then(res => {
          this.loading = false;
          console.log(res.data);
          this.user = res.data;

          //change here for this.user.type == 1 faceid activation
          if(this.user.type == 1){

           navigator.mediaDevices.getUserMedia({ video: true }) 
            .then(mediaStream => {console.log("mediaStream", mediaStream)
              this.videoAvailable = true;

              this.$refs.player.setAttribute("style", "display:block");
              this.$refs.player.srcObject = mediaStream;

              const track = mediaStream.getVideoTracks()[0];
              console.log(track)
              this.imageCapture = new ImageCapture(track);
              console.log(this.imageCapture)

            })
            .catch(error => {
              
              this.$notify({
                type: "error",
                group: "foo",
                title: "Camera não encontrada"
              });
            });
          }

          if(!res.data.needFillData){
            this.showStudentForm = false;
          }else{
            this.showStudentForm = true;
          }
          
        })
        .catch(error => {

          this.videoAvailable = false;
          console.log("ERROR", error)
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro ao realizar o login"
          });
          this.loading = false;
        });
    },
    async login() {

      let image;

      this.formData = new FormData();

      if(this.imageCapture != null){

        await this.imageCapture.takePhoto()
        .then(blob => {
            console.log("BLOB", blob)
            this.formData.append("file", blob);
        console.log(this.formData)
            return true;

        })
        .catch(error => {
              this.$notify({
                type: "error",
                group: "foo",
                title: "Webcam não encontrada!"
              });
            });
      }
      
      this.formData.append("email", this.user.email);
      this.formData.append("password", this.user.password);

      this.loading = true;
      const path = this.$global.endpoint + "/user/login";

      let config = {
        headers: {
          enctype: 'multipart/form-data',
          processData: false,
          contentType: false,
          timeout: 0
        }
      }

      axios
        .post(path, this.formData, config)
        .then(res => {
          this.loading = false;
          this.$store.commit("change_user", res.data.user);
          this.$router.push("/home/dashboard");
        })
        .catch(error => {
          
          this.$notify({
            type: "error",
            group: "foo",
            title: (this.user.type != 1 ? "Senha inválida" : "Senha ou autenticação inválida")
          });
          this.loading = false;
          console.error(error);
        });
    }
  },
  created() {
    if (this.$route.query.purchaseitem) {
      let productIds = JSON.parse(this.$route.query.purchaseitem);
      console.log(productIds);
      this.loading = true;
      this.purchasing = true;
      for (let i = 0; i < productIds.length; i++) {
        this.getProductDetails(productIds[i]);
      }
    }

    //window.open('http://www.google.com', '_blank');
  }
};
</script>
